import axios from 'axios';

const namespaced = true;

const state = () => ({
  path: '',
  delimiter: '/',
  objects: [],
});

const actions = {
  async load({ commit }) {
    const { data } = await axios.get('/filesystem/tree');
    commit('SET_OBJECTS', data);
  },
  set_path({ commit }, data) {
    commit('set_path', data);
  },
  ADD_PATH({ commit }, data) {
    commit('ADD_PATH', data);
  },
};

const mutations = {
  SET_OBJECTS(state, data) {
    state.objects = data;
  },
  set_path(state, data) {
    state.path = data;
  },
  ADD_PATH(state, data) {
    state.path = `${state.path}${state.delimiter}${data}`;
  },
};

const getters = {};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
